$(function() {
	$(".anclaNextSection").click(function(){
        $('html, body').animate({
            scrollTop: $(this).closest('section').next().offset().top
        }, 1000);
	})
})